export const ScreenThreshold = {
	EXTRA_SMALL: 768,
	SMALL: 1024,
	MEDIUM: 1440,
	LARGE: 1760,
};

export type ScreenThreshold = (typeof ScreenThreshold)[keyof typeof ScreenThreshold];

export const ScreenSize = {
	EXTRA_SMALL: 'xs',
	SMALL: 'sm',
	MEDIUM: 'md',
	LARGE: 'lg',
	EXTRA_LARGE: 'xl',
} as const;
export type ScreenSize = (typeof ScreenSize)[keyof typeof ScreenSize];
